import { useAdminT } from "../../../../hooks/useAdminT";

interface StatusBadgeProps {
    status: boolean | string;
    size?: "sm" | "md";
}

export function StatusBadge({ status, size = "sm" }: StatusBadgeProps) {
    const { t } = useAdminT();

    const statusConfig: Record<string, { bg: string; text: string; dot: string; key: string }> = {
        true: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", key: "common.active" },
        false: { bg: "bg-slate-100", text: "text-slate-500", dot: "bg-slate-400", key: "common.inactive" },
        published: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", key: "common.published" },
        draft: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500", key: "common.unpublished" },
        new: { bg: "bg-blue-50", text: "text-blue-700", dot: "bg-blue-500", key: "status.new" },
        pending: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500", key: "status.contacted" },
        resolved: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", key: "status.closed" },
        available: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", key: "status.available" },
        sold: { bg: "bg-red-50", text: "text-red-700", dot: "bg-red-500", key: "status.sold" },
        resale: { bg: "bg-violet-50", text: "text-violet-700", dot: "bg-violet-500", key: "status.resale" },
    };

    const key = typeof status === "boolean" ? String(status) : (status || "false").toLowerCase();
    const config = statusConfig[key] || statusConfig["false"];

    const sizeClasses = size === "sm"
        ? "text-[10px] px-2.5 py-1 gap-1.5"
        : "text-xs px-3 py-1.5 gap-2";

    return (
        <span
            className={`inline-flex items-center font-semibold uppercase tracking-wide rounded-sm border ${config.bg} ${config.text} ${sizeClasses}`}
            style={{ borderColor: "currentColor", borderOpacity: 0.15 }}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
            {t(config.key)}
        </span>
    );
}
